/**
 * Insert a freshly created post at the top of a feed list, removing any
 * duplicate by id. Ranked feeds often bury brand-new zero-engagement posts.
 */
export function prependCreatedPost(posts, created) {
  if (!created) return Array.isArray(posts) ? posts : [];
  const createdId = created.post_id ?? created.postId;
  const list = Array.isArray(posts) ? posts : [];
  if (createdId == null) return [created, ...list];
  const rest = list.filter((p) => {
    const id = p.post_id ?? p.postId;
    return String(id) !== String(createdId);
  });
  return [created, ...rest];
}

export function postIdOf(post) {
  if (!post) return null;
  return post.post_id ?? post.postId ?? null;
}

/** Normalize feed API payloads that may be a bare array or { pinned, posts }. */
export function normalizeFeedResponse(data) {
  if (Array.isArray(data)) {
    return { pinned: [], posts: data };
  }
  return {
    pinned: Array.isArray(data?.pinned) ? data.pinned : [],
    posts: Array.isArray(data?.posts) ? data.posts : [],
  };
}

/**
 * Merge pinned + regular posts for display without duplicates.
 * Pinned (active critical) posts always come first.
 */
export function mergePinnedFeed(pinned, posts) {
  const pinList = Array.isArray(pinned) ? pinned : [];
  const rest = Array.isArray(posts) ? posts : [];
  const pinnedIds = new Set(
    pinList.map((p) => String(postIdOf(p))).filter((id) => id !== "null")
  );
  const dedupedRest = rest.filter((p) => !pinnedIds.has(String(postIdOf(p))));
  return [...pinList, ...dedupedRest];
}

export function isPostCriticallyActive(post, now = Date.now()) {
  const until = post?.critical_until ?? post?.criticalUntil;
  if (!until) return false;
  return new Date(until).getTime() > now;
}

export function formatCriticalRemaining(until, now = Date.now()) {
  if (!until) return null;
  const ms = new Date(until).getTime() - now;
  if (ms <= 0) return "Expired";
  const hours = Math.floor(ms / (60 * 60 * 1000));
  const mins = Math.floor((ms % (60 * 60 * 1000)) / (60 * 1000));
  if (hours >= 1) return `${hours}h ${mins}m left`;
  return `${Math.max(1, mins)}m left`;
}
